export default __webpack_public_path__ + "static/media/Add_Image.d351d9d4.svg";